import { openDocumentSignaturesDisplayModal } from "../components/modals/document-signatures-display";

export type OpenDocumentSignaturesHookProps = {
    openSignatureModal: (documentId: string) => void
};

export const useOpenDocumentSignatures = () : OpenDocumentSignaturesHookProps => {

    const openSignatureModalHandler = (documentId: string) : void => {
        openDocumentSignaturesDisplayModal({ documentId: documentId })
    };

    return {
        openSignatureModal: openSignatureModalHandler
    };
};